import { useEffect, useState } from "react";

import { getItemFromLocalStorage, setItemInLocalStorage } from "./localStorage";

export function useLocalStorage<T>(key: string, initialValue: T | (() => T)) {
  const isClient = typeof window !== "undefined"; // Check if running on the client side
  const [value, setValue] = useState<T>(() => {
    if (isClient && key) {
      const jsonValue = getItemFromLocalStorage(key);
      if (jsonValue != null && jsonValue !== undefined && jsonValue !== "undefined") return jsonValue;
    }

    if (typeof initialValue === "function") {
      return (initialValue as () => T)();
    } else {
      return initialValue;
    }
  });

  useEffect(() => {
    if (isClient && key) setItemInLocalStorage(key, value);
  }, [key, value, isClient]);

  // Add event listener to prevent direct manipulation of localStorage
  useEffect(() => {
    // const handleBeforeUnload = () => {
    //     localStorage.setItem(key, JSON.stringify(value));
    // };
    // window.addEventListener("beforeunload", handleBeforeUnload);
    // return () => {
    //     window.removeEventListener("beforeunload", handleBeforeUnload);
    // };
  }, [key, value]);

  return [value, setValue] as [typeof value, typeof setValue];
}
